import { Box, Stack, styled } from "@mui/material"

export const GridParent = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const BankAccountsContainer = styled(Stack)`
  display: flex;
  flex: 1;
  background: white;
  padding: 20px;
  position: relative;
`
